import { hasErrorCode } from "./errors";

/** Create tenant  */
export type CreateTenantPayload = {
  organizationName: string;
  organizationNumber: string;
  parentId: string;
};

/** Edit tenant  */
export type EditTenantPayload = {
  organizationName: string;
  organizationNumber: string;
};

export const isTenantIdAlreadyAddedErrorResponse = (error: unknown) =>
  hasErrorCode(error, "ERROR_TENANT_ID_ALREADY_ADDED");
